import gsap from 'gsap'
import CountrySelectorSmall from '../components/CountrySelectorSmall.vue'

export default {
  name: 'LeihboxHeader',
  components: {
    CountrySelectorSmall,
  },
  data() {
    return {
      isHidden: 0,
      extraScroll: 100,
      isSmall: false,
      initYPosition: 0,
      scroll: {
        direction: 0,
        prev: 0,
        current: 0,
      },
    }
  },
  props: {
    isVideo: {
      type: Number,
      value: '',
    },
  },
  mounted() {
    if (this.isVideo) {
      this.onResize()
      this.setLogoPosition()
    } else {
      gsap.to(this.$refs.logo, { opacity: 1 })
    }
  },

  created() {
    if (this.isVideo) {
      window.addEventListener('resize', this.onResize)
    }

    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onResize() {
      this.spacing = window.getComputedStyle(this.$refs.inner, null).getPropertyValue('padding-top').replace('px', '')
      this.setLogoPosition()
    },
    onScroll() {
      this.scroll.current = window.scrollY

      if (this.scroll.current > this.scroll.prev) {
        this.scroll.direction = 1
      } else {
        this.scroll.direction = -1
      }

      if (this.scroll.direction === 1) {
        const top = this.isVideo ? window.innerHeight + this.extraScroll : this.extraScroll * 1.5
        // scroll down
        if (this.scroll.current > top) {
          this.isHidden = 1
        } else {
          this.isHidden = 0
        }
      }

      if (this.scroll.direction === -1) {
        // scroll up
        this.isHidden = 0
      }

      this.scroll.prev = this.scroll.current

      if (this.isVideo) {
        this.updateLogoPosition()
      }
    },
    setLogoPosition() {
      const calcY = this.getLogoPosition()
      this.initYPosition = calcY

      if (!this.isSmall) {
        gsap.set(this.$refs.logo, { y: calcY, scale: 3.2, transformOrigin: '0 0' })
        gsap.to(this.$refs.logo, { opacity: 1 })
      }
    },
    updateLogoPosition() {
      const logoSizes = this.$refs.logo.getBoundingClientRect()

      if (logoSizes.y <= this.spacing && this.scroll.direction === 1) {
        const diff = this.spacing - logoSizes.y
        if (!this.isSmall) {
          gsap.to(this.$refs.logo, { scale: 1, z: 0 })
        }
        gsap.set(this.$refs.logo, { y: '+=' + diff })
        this.isSmall = true
      }

      const headerPosition = this.getHeaderPosition()

      if (this.scroll.direction === -1) {
        if (headerPosition < this.spacing) {
          const diff = this.spacing - logoSizes.y
          gsap.set(this.$refs.logo, { y: '+=' + diff })
        } else {
          const calcY = this.getLogoPosition()
          this.initYPosition = calcY
          gsap.to(this.$refs.logo, { y: this.initYPosition })
        }

        if (headerPosition > -200 && headerPosition < this.spacing && this.isSmall) {
          this.isSmall = false
          gsap.to(this.$refs.logo, { scale: 3.2, z: 0 })
        }
      }
    },
    getLogoPosition() {
      const headerPosition = this.getHeaderPosition()
      const logoSizes = this.$refs.nav.getBoundingClientRect()

      return headerPosition - logoSizes.y
    },
    getHeaderPosition() {
      const header = document.getElementsByClassName('open_video_header')
      const headerSizes = header[0].getBoundingClientRect()

      return headerSizes.y + headerSizes.height
    },
  },
}
